
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This tool is not a medical predictor, and should be used for informational and research purposes only. Please carefully
consider the parameters you choose. Interpret and use the simulated results responsibly. Authors are not liable for any
direct or indirect consequences of this usage.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;